const radius = {
  0: '0px',
  10: '2px',
  20: '4px',
} as const

export default radius
